/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Search } from './Search.js';
import {
    SearchFromJSON,
    SearchFromJSONTyped,
    SearchToJSON,
} from './Search.js';

/**
 * 
 * @export
 * @interface CreateSearchResponse
 */
export interface CreateSearchResponse {
    /**
     * 
     * @type {Search}
     * @memberof CreateSearchResponse
     */
    data?: Search;
    /**
     * 
     * @type {number}
     * @memberof CreateSearchResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSearchResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CreateSearchResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CreateSearchResponse interface.
 */
export function instanceOfCreateSearchResponse(value: object): boolean {
    return true;
}

export function CreateSearchResponseFromJSON(json: any): CreateSearchResponse {
    return CreateSearchResponseFromJSONTyped(json, false);
}

export function CreateSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SearchFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CreateSearchResponseToJSON(value?: CreateSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': SearchToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

